let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gUg0Z")).then(() => parcelRequire('1rjw0'));